/**
 * 간단한 텍스트 포맷 유틸리티
 *
 * Gemini가 생성한 HTML에서 **텍스트**를 <b>텍스트</b>로 변환
 */

/**
 * **텍스트**를 <b>텍스트</b>로 변환
 *
 * @param html - Gemini가 생성한 HTML 문자열
 * @returns ** 마크다운이 <b> 태그로 변환된 HTML
 *
 * @example
 * ```typescript
 * const html = convertBoldMarkdown('이것은 **중요한** 내용입니다.');
 * // 결과: '이것은 <b>중요한</b> 내용입니다.'
 * ```
 */
export const convertBoldMarkdown = (html: string): string => {
  if (!html) return '';

  // **텍스트** 패턴을 <b>텍스트</b>로 변환
  // Non-greedy 매칭으로 가장 가까운 **까지만 매칭
  return html.replace(/\*\*(.+?)\*\*/g, '<b>$1</b>');
};
